"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _elements = require("../../styles/elements");

var _Modal = require("./Modal.styles");

var Description = function Description(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return (0, _jsxRuntime.jsx)("p", {
    className: (0, _clsx["default"])('grui text-center mt-7', className),
    css: [_elements.paragraph.styles.preflight, _Modal.styles.description, process.env.NODE_ENV === "production" ? "" : ";label:Description;"],
    children: children
  });
};

Description.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string
};
Description.defaultProps = {
  children: undefined,
  className: undefined
};
var _default = Description;
exports["default"] = _default;
//# sourceMappingURL=Description.js.map